import React from "react";
import { useNavigate } from "react-router-dom";

// UI-09: every crumb leads to a page that exists (Scraps pointed at /items/scraps, others at routes that were never
// made or at paths with a literal ":id"); a crumb for a single record goes to its list
const routeMapping = {
  Home: "/dashboard",
  Login: "/login",
  Dashboard: "/dashboard",
  Reporting: "/dashboard/reporting",
  "Product Performance": "/dashboard/reporting/product-performance",
  "Product Report": "/dashboard/reporting/product-report",
  "Purchase Performance": "/dashboard/reporting/purchase-performance",
  "Payment Due Report": "/dashboard/reporting/payment-due-report",
  "Payment-Due": "/dashboard/reporting/payment-due-report",
  "Price List": "/dashboard/reporting/price-list",
  "Profit & Loss": "/dashboard/reporting/profit-loss-report",
  Approvals: "/dashboard/approvals",
  Users: "/users",
  "Users List": "/users/users-list",
  "User Details": "/users",
  "User-Detail": "/users",
  "Access Management": "/access-management",
  "All Role Access": "/access-management",
  Purchase: "/purchases",
  Purchases: "/purchases",
  "All Purchase Orders": "/purchases",
  "All Purchase-Orders": "/purchases",
  "Edit Purchase Order": "/purchases",
  Attendance: "/attendance",
  "Employee Report": "/attendance/employee-report",
  Items: "/items",
  "All Items": "/items",
  Assets: "/items/assets",
  "Assets Table": "/items/assets",
  Categories: "/items/categories",
  Subitems: "/items/subitems",
  Scraps: "/items/scrap",
  Manufacturing: "/manufacturing",
  Products: "/manufacturing",
  "Products Management": "/manufacturing",
  "Add Product": "/manufacturing/add-product",
  Parts: "/manufacturing/parts-management",
  "Create Product": "/manufacturing/create-product",
  "Edit Product": "/manufacturing",
  "Sales Service": "/sales-service",
  "Sales-Services": "/sales-service",
  "Order Management": "/sales-service",
  Orders: "/sales-service",
  "Dealer Order": "/sales-service/dealer-order",
  "Dealer Orders": "/sales-service/dealer-order",
  "Create Order": "/sales-service/create-order",
  "Product Service": "/sales-service/product-service",
  "Services-Orders": "/sales-service/product-service",
  "Create Service": "/sales-service/create-service",
  "Edit Service": "/sales-service/product-service",
  "Warranty Management": "/sales-service/manage-warranty",
  Warranties: "/sales-service/manage-warranty",
  Payment: "/payment",
  Payments: "/payment",
  "Payment Management": "/payment",
  "Payment-management": "/payment",
  "Payment History": "/payment",
  "Transaction-History": "/payment",
  "Income Management": "/payment/income-management",
  "Other Income": "/payment/income-management",
  Notification: "/notification",
  "Session Timeout": "/session-timeout",
};

const BreadCrumbs = ({ title, customClasses }) => {
  const navigate = useNavigate();

  const handleNavigation = (breadcrumb) => {
    const trimmedBreadcrumb = breadcrumb.trim(); 

    const path = routeMapping[trimmedBreadcrumb];

    if (path) {
      navigate(path);
    } 
  };

  const breadcrumbs = title.split("/").filter(Boolean);

  return (
    <div
      className={`font-poppins bg-white cursor-pointer md:rounded-[0.42vw] rounded-[1vw] md:py-10px-vw text-[#828690] text-[3.5vw] md:text-20px-vw ${customClasses}`}
    >
      {breadcrumbs.map((crumb, index) => {
        const isActive = index === breadcrumbs.length - 1;
        return (
          <span
            key={index}
            className={
              isActive ? "text-[#0074ff] bg-white" : "text-[#828690] bg-white"
            }
            onClick={() => handleNavigation(crumb)}
          >
            {crumb}
            {index < breadcrumbs.length - 1 && " / "}
          </span>
        );
      })}
    </div>
  );
};

export default BreadCrumbs;
